import { Image as ChakraImage, Link as ChakraLink } from "@chakra-ui/react";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";
import type { ComponentPropsWithoutRef } from "react";
import { forwardRef } from "react";

type ChakraLinkProps = ComponentPropsWithoutRef<typeof ChakraLink>;

export type LinkProps = Omit<ChakraLinkProps, "href" | "as"> &
  Pick<
    NextLinkProps,
    "href" | "replace" | "scroll" | "shallow" | "prefetch"
  > & {
    passHref?: boolean;
    legacyBehavior?: boolean;
  };

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  {
    href,
    replace,
    scroll,
    shallow,
    prefetch,
    passHref,
    legacyBehavior,
    ...props
  },
  ref,
) {
  return (
    <NextLink
      href={href}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      prefetch={prefetch}
      passHref={passHref ?? true}
      legacyBehavior={legacyBehavior ?? true}
      target={props.target}
    >
      <ChakraLink ref={ref} {...props} />
    </NextLink>
  );
});

export const Image = ChakraImage;
